import React from 'react';
import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';

function TableauWidgetSettings({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const embedded_url = useSelector(state => state.dashboard.widgets[widgetId].settings?.embedded_url);

    return (
        <fieldset>
            <label style={{ width: '100%' }} htmlFor="embedded_url">
            {I18n.t('embedded_url')}
            </label>
            <input 
                type="text" 
                className="form-control"
                name="embedded_url" 
                value={embedded_url} 
                onChange={e => (setAttribute('settings.embedded_url', e.target.value))} 
            />
        </fieldset>
    )
}

export default TableauWidgetSettings;
